import isEqual from 'lodash.isequal';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import DealReview from './DealReview/DealReview';
import DealLike from './DealLike/DealLike';
import DealShare from './DealShare/DealShare';
import DealReport from './DealReport/DealReport';

/**
 * 상품리뷰 컴포넌트
 */
function StoreReview() {
  const { reviewType, representativeReview } = useSelector(
    state => ({
      reviewType: state.default.reviewType
        ? state.default.reviewType.response
        : null,
      representativeReview: state.default.representativeReview
        ? state.default.representativeReview.response
        : null,
    }),
    isEqual
  );
  const isDealReviewRender = !(
    !TMON.htStaticData.isShowReview ||
    !reviewType ||
    (reviewType && (reviewType.data === '' || reviewType.data === 'N')) ||
    !representativeReview ||
    TMON.oApp.oUtil.isEmpty(representativeReview.data) ||
    !representativeReview.data.reviewAvgScore ||
    isNaN(representativeReview.data.reviewAvgScore)
  );
  const isPW = TMON.sDevice === 'PW';

  return (
    <Fragment>
      {isDealReviewRender && !isPW && (
        <DealReview
          reviewType={reviewType.data}
          representativeReview={representativeReview}
        />
      )}
      <div className="deal_etc">
        <DealLike />
        <DealShare />
        { TMON.sDevice === 'PW' && <DealReport /> }
      </div>
      {isDealReviewRender && isPW && (
        <DealReview
          reviewType={reviewType.data}
          representativeReview={representativeReview}
        />
      )}
    </Fragment>
  );
}

export default StoreReview;
